var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGuitarFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H23.4015C23.7307 0 24 0.297307 24 0.660683V19.0937C24 19.5232 23.8204 19.9196 23.5212 20.1508L12.7182 28.971C12.2993 29.3013 11.7307 29.3013 11.2818 28.971L0.478803 20.1839C0.179551 19.9196 0 19.5232 0 19.1268V0.660683C0 0.297307 0.269327 0 0.598504 0H12Z",
    fill: "#2D9CDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6532 0V11.562",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6536 6.73901C8.7683 6.73901 6.43414 7.66397 6.43414 10.2737C6.43414 12.8834 7.4516 14.2047 7.4516 15.394C7.4516 17.6403 4.6087 18.6643 4.6087 23.5204",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3468 0V11.562",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3468 6.73901C15.2321 6.73901 17.5663 7.66397 17.5663 10.2737C17.5663 12.8834 16.5488 14.2047 16.5488 15.394C16.5488 17.6403 19.3917 18.6643 19.3917 23.5204",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6409 16.4511C13.197 16.7154 14.5436 15.2619 14.3042 13.5111C14.1546 12.421 13.3466 11.5621 12.389 11.3969C10.8329 11.1326 9.48626 12.5861 9.72566 14.3369C9.87529 15.394 10.6833 16.2859 11.6409 16.4511Z",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGuitarFill);
export default __webpack_public_path__ + "static/media/icon-guitar-fill.a301c5d630fd27823ef896046006f372.svg";
export { ForwardRef as ReactComponent };